import React from 'react';
import { SyncAltIcon } from 'tuui';
import { RealizeConnect } from '../icons/RealizeConnect';
import { getPlatformIcon } from '../utils/3p-platforms';
import styles from '../pages/thirdPartyConnect.module.scss';

export const IconsList = ({ platform }) => {
    const PlatformIcon = getPlatformIcon(platform);

    return (
        <div className={styles['icon-list']}>
            <RealizeConnect />
            <SyncAltIcon />
            <PlatformIcon />
        </div>
    );
};
